export default "__VITE_ASSET__CZSNqnHK__"